import DatoLink from '@/components/DatoLink/DatoLink'
import { DatoLinkFragment } from '@/components/DatoLink/DatoLink.generated'
import SearchHistory from '@/components/Search/SearchHistory'
import { SearchHistoryItem } from '@/hooks/useSearchHistory'

export default function NoResultsView({
	query,
	text,
	noResultContact,
	contactPageLink,
	onClose,
	searchHistory,
	onSearchClick,
	translations,
}: {
	query: string
	text: string
	noResultContact: string
	contactPageLink: DatoLinkFragment
	onClose: () => void
	searchHistory: SearchHistoryItem[]
	onSearchClick: (query: string) => void
	translations?: {
		recentSearches?: string
		noResults?: string
		results?: string
	}
}) {
	return (
		<div className="flex flex-col items-center w-full h-full justify-center gap-12">
			<div className="flex flex-col gap-4">
				<div
					id="search-no-result"
					className="flex items-center justify-center gap-3 mt-8 text-gray-400 max-w-lg text-center"
				>
					{`${text} "${query}".`}
				</div>
				<div className="flex justify-center">
					<div className="flex items-center justify-center gap-3 text-gray-400">
						{noResultContact}
					</div>
					<div className="flex items-center justify-center ml-1">
						<DatoLink
							fragment={contactPageLink}
							className="underline text-red-500 font-bold hover:text-red-600 focus:outline focus:outline-2 focus:outline-red-500 transition"
							onClick={onClose}
						>
							{contactPageLink.__typename === 'InternalLinkRecord'
								? contactPageLink.label.toLowerCase()
								: 'contact us'}
						</DatoLink>
					</div>
				</div>
			</div>

			<SearchHistory
				searchHistory={searchHistory}
				onSearchClick={onSearchClick}
				translations={translations}
			/>
		</div>
	)
}
